module.exports = __webpack_public_path__ + "img/puck-explode.2b65cc2b.png";